import {t} from "i18next";

interface MultilineTextProps {
    x: number;
    y: number;          // 这是矩形的垂直中心 y
    text: string;
    textAnchor?: 'start' | 'middle' | 'end';
    fontSize?: number;
    fontFamily?: string;
    fill?: string;
    lineHeight?: number; // 单位：em，默认 1.2
}

export const MultilineText: React.FC<MultilineTextProps> = ({
                                                                x,
                                                                y,
                                                                text,
                                                                textAnchor = 'start',
                                                                fontSize = 14,
                                                                fontFamily = 'PoppinsMedium',
                                                                fill = 'black',
                                                                lineHeight = 1.2,
                                                            }) => {
    const lines = text.split('\n');
    const isSingleLine = lines.length === 1;

    if (isSingleLine) {
        // 单行：用 dominant-baseline="middle" 精准垂直居中
        return (
            <text
                x={x}
                y={y}
                textAnchor={textAnchor}
                dominantBaseline="middle"
                fontSize={fontSize}
                fontFamily={fontFamily}
                fill={fill}
            >
                {text}
            </text>
        );
    }

    // 多行：手动计算起始偏移，不使用 dominantBaseline
    const lineCount = lines.length;
    const dy0 = -((lineCount - 1) * lineHeight) / 4 + 'em';

    return (
        <text
            x={x}
            y={y}
            textAnchor={textAnchor}
            fontSize={fontSize}
            fontFamily={fontFamily}
            fill={fill}
        >
            {lines.map((line, i) => (
                <tspan
                    x={x}
                    dy={i === 0 ? dy0 : `${lineHeight}em`}
                    key={i}
                >
                    {line}
                </tspan>
            ))}
        </text>
    );
};

export function getLeftPartSvg() {
    return (
        <svg width="422" height="245" viewBox="0 0 422 245" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group 427323154">
                {/* Group 427323148 */}
                <g id="Group 427323148">
                    <rect id="Rectangle 34626459" x="1.14674" y="22.553" width="126.141" height="89.4456" rx="12.6141"
                          fill="#F9DAD4" stroke="#F7AAB1" stroke-width="2.29348"/>
                    <MultilineText
                        x={64.217}
                        y={67.276}
                        text={t('Creative writing')}
                        textAnchor="middle"
                        fontSize={14}
                        fontFamily="PoppinsMedium"
                        fill="black"
                    />
                </g>

                {/* Group 427323149 */}
                <g id="Group 427323149">
                    <rect id="Rectangle 34626459_2" x="147.929" y="1.14674" width="126.141" height="89.4456"
                          rx="12.6141"
                          fill="#CBEAF5" stroke="#A0C9F5" stroke-width="2.29348"/>
                    <text x="211.000"
                          y="45.870"
                          text-anchor="middle"
                          dominant-baseline="middle" font-family="PoppinsMedium" font-size="14" fill="black">
                        {t('Research')}
                    </text>
                </g>

                {/* Group 427323150 */}
                <g id="Group 427323150">
                    <rect id="Rectangle 34626459_3" x="294.712" y="22.553" width="126.141" height="89.4456" rx="12.6141"
                          fill="#E8D9FB" stroke="#CBB3F8" stroke-width="2.29348"/>
                    <MultilineText
                        x={357.783}
                        y={67.276}
                        text={t('Swipe files')}
                        textAnchor="middle"
                        fontSize={14}
                        fontFamily="PoppinsMedium"
                        fill="black"
                    />
                </g>

                {/* Group 427323151 */}
                <g id="Group 427323151">
                    <rect id="Rectangle 34626459_4" x="1.14674" y="132.64" width="126.141" height="89.4456" rx="12.6141"
                          fill="#CBEDE8" stroke="#93DDC9" stroke-width="2.29348"/>
                    <MultilineText
                        x={64.217}
                        y={177.363}
                        text={t('Second brain')}
                        textAnchor="middle"
                        fontSize={14}
                        fontFamily="PoppinsMedium"
                        fill="black"
                    />
                </g>

                {/* Group 427323152 */}
                <g id="Group 427323152">
                    <rect id="Rectangle 34626459_5" x="147.929" y="154.046" width="126.141" height="89.4456" rx="12.6141"
                          fill="#F8E9CB" stroke="#F6D390" stroke-width="2.29348"/>
                    <MultilineText
                        x={211.0}
                        y={198.769}
                        text={t('Idea repository')}
                        textAnchor="middle"
                        fontSize={14}
                        fontFamily="PoppinsMedium"
                        fill="black"
                    />
                </g>

                {/* Group 427323153 */}
                <g id="Group 427323153">
                    <rect id="Rectangle 34626459_6" x="294.712" y="132.64" width="126.141" height="89.4456" rx="12.6141"
                          fill="#F3D6F5" stroke="#F2ABD3" stroke-width="2.29348"/>
                    <MultilineText
                        x={357.783}
                        y={177.363}
                        text={t('Mood board')}
                        textAnchor="middle"
                        fontSize={14}
                        fontFamily="PoppinsMedium"
                        fill="black"
                    />
                </g>
            </g>
        </svg>
    );
}